
/* eslint-disable */
import styles from './style.module.scss';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import { t } from '@web-solutions/module-localization';
import { useNav } from 'src/onboarding/hooks/nav';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { ReactComponent as ActiveSVG } from '../../assets/images/check.svg';
import Analytics from '@web-solutions/module-analytics';

const handleContinue = (currentIndex: number, onNext: () => void) => {
  Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
    page: 'glp-diet',
  });
  onNext();
};

const OptionItem = ({ title }: { title: string }) => (
  <div className={styles.option}>
    <ActiveSVG />
    <Text semibold>{title}</Text>
  </div>
);

function Page() {
  const { onNext, onPrev, currentIndex } = useNav();

  const GLP_DIET_OPTIONS = [
    t('onboarding.glpDiet.options.weightLoss'),
    t('onboarding.glpDiet.options.sideEffects'),
    t('onboarding.glpDiet.options.metabolism'),
    t('onboarding.glpDiet.options.results'),
  ] as const;

  return (
    <div className={styles.page}>
      {currentIndex !== 0 && (
        <div className={styles.back} onClick={onPrev}>
          <BackIcon />
        </div>
      )}

      <div className={styles.content}>
        <div className={styles.wrapperInfo}>
          <Title className={styles.title}>{t('onboarding.glpDiet.title')}</Title>

          <Text semibold className={styles.description}>
            {t('onboarding.glpDiet.subTitle')}
          </Text>

          <div className={styles.options}>
            {GLP_DIET_OPTIONS.map((title, index) => (
              <OptionItem key={index} title={title} />
            ))}
          </div>

          <div className={styles.image} />
        </div>
      </div>

      <div className={styles.continue}>
        <div className={styles.blur} />
        <Button
          onClick={() => handleContinue(currentIndex, onNext)}
          title={t('onboarding.glpDiet.continue')}
        />
      </div>
    </div>
  );
}

export default Page;
